import { useQuery } from '@tanstack/react-query'
import { request } from 'Features/Auth/axios-client'
import { Tenant, TenantListResponse } from './TenantList.types'

const fetchTenantList = async () => {
  const { data } = await request({
    url: `/user-tenants`,
  })
  return data
}

export const useTenantListData = () => {
  return useQuery<Tenant[], Error>({
    queryKey: ['tenants'],
    queryFn: fetchTenantList,
    select: (data: TenantListResponse) => data.data,
  })
}
